// extracted by mini-css-extract-plugin
export default {"dropzone":"DropZone_dropzone__xrsiJ"};